import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import seoData from "../seoData/TermsOfUse.json"

const TermsOfUse = () => {
  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Terms Of Use" page="Terms Of Use" />
        <div className="section-padding privacy-policy-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-policy-content">
                  <div className="section-title">
                    <h5 className="title">
                      This Terms of Use was last updated on August 25th, 2026.
                    </h5>
                  </div>
                  <p>
                    ITCODE InfoTech (abbreviation - IIPL) maintains and hosts
                    this website as a platform to exhibit information about
                    its services and products.
                  </p>
                  <p>
                    Your access and usage of the website is subject to the
                    following terms and conditions and future revisions if any,
                    (“Terms and Conditions”) and all applicable laws. By
                    accessing and browsing this website, you agree to the
                    following terms & conditions.
                  </p>

                  <h4>1. Acceptance of terms</h4>
                  <p>
                    By accessing, browsing, or otherwise using this website, you
                    confirm that you accept these Terms and Conditions and agree
                    to comply with them. If you do not agree with any part of
                    these terms, please do not use this website. We may update
                    these Terms and Conditions from time to time, and your
                    continued use of the website after any changes constitutes
                    acceptance of the revised terms.
                  </p>

                  <h4>2. Use of the website</h4>
                  <p>
                    The website, including all the content, information,
                    software, products and services provided on the website,
                    are offered on an “as is” and “as available” basis. ITCODE
                    InfoTech expressly disclaims all warranties of any kind,
                    whether express or implied, including, but not limited to,
                    the implied warranty of merchantability, fitness for a
                    particular purpose and non-infringement. You agree to use
                    this website only for lawful purposes and in a manner that
                    does not infringe the rights of, or restrict or inhibit the
                    use and enjoyment of this site by, any third party.
                  </p>
                  <p>
                    It is illegitimate to post or send anything through this
                    website that is illegal, threatening, harassing,
                    defamatory, libellous, obscene, pornographic, or profane
                    content, as well as any content that could incite behaviour
                    that would be illegal, give rise to civil disorder, or
                    otherwise violate the law.
                  </p>

                  <h4>3. Intellectual property</h4>
                  <p>
                    The content and the projects described or displayed on the
                    website are subject to change without notice. Copyright may
                    exist on any future materials. Unauthorized recording or use
                    of such materials would be considered infringement of the
                    applicable TRIPS. The materials you see on the website
                    either belong to ITCODE InfoTech or were used with their
                    consent. Unless otherwise expressly permitted by these Terms
                    and Conditions or with ITCODE InfoTech's prior written
                    consent, you are not permitted to reproduce, distribute, or
                    otherwise use these materials yourself or on behalf of
                    anyone else. Any unauthorized use of the photographs,
                    graphics, logos, or written content on this site could be
                    against copyright, trademark, privacy, and publicity laws.
                  </p>

                  <h4>4. Third-party links</h4>
                  <p>
                    Accessing any other website, or one that is connected to or
                    similar to ours but not under the control of the company,
                    is the sole responsibility of the user and not the company —
                    browse at your own risk. ITCODE InfoTech may offer links on
                    the website to other websites; their inclusion is merely for
                    your convenience and shouldn't be seen as an approval of the
                    website's owner or sponsor of the information found there.
                    With the exception of the Non-Excludable Rights described
                    below, ITCODE InfoTech makes no representations or
                    warranties, either stated or implied, as to the truth,
                    accuracy, completeness, or legality of any materials or
                    information found on such websites.
                  </p>

                  <h4>4a. Advertising</h4>
                  <p>
                    This website may display advertisements served by
                    third-party advertising networks, including Google
                    AdSense. These advertisements are provided by independent
                    advertisers, and ITCODE InfoTech does not endorse, and is
                    not responsible for, the content, products, services, or
                    claims made in any advertisement. Interactions with an
                    advertisement, including any purchase or transaction, are
                    solely between you and the advertiser. For details on how
                    third-party vendors use cookies to serve ads on this
                    site, see the Advertising and third-party cookies section
                    of our{" "}
                    <a href={process.env.PUBLIC_URL + "/privacy-policy"}>
                      Privacy Policy
                    </a>
                    .
                  </p>

                  <h4>5. Disclaimer of warranties and limitation of liability</h4>
                  <p>
                    ITCODE InfoTech assumes no responsibility, and shall not be
                    liable for, any damage to, or viruses that may infect your
                    system, equipment or any other assets on account of your
                    access to, use of, or browsing this website, or your
                    downloading of any materials, data, text, images, video, or
                    audio from this website. To the fullest extent permitted by
                    applicable law, ITCODE InfoTech shall not be liable for any
                    indirect, incidental, special, consequential, or punitive
                    damages, or any loss of profits or revenues, whether
                    incurred directly or indirectly, arising out of your access
                    to or use of, or inability to access or use, this website.
                    Nothing in these Terms limits or excludes any liability that
                    cannot be limited or excluded under applicable law (the
                    “Non-Excludable Rights”).
                  </p>

                  <h4>6. Services, quotes, and refund policy</h4>
                  <p>
                    Information about our services, timelines, and pricing
                    provided on this website is indicative and subject to
                    confirmation in a signed proposal, statement of work, or
                    service agreement between ITCODE InfoTech and the client;
                    it does not itself constitute a binding offer. Payment
                    terms, milestones, and any refund or cancellation
                    provisions applicable to a specific engagement are set out
                    in that agreement and take precedence over any general
                    statement made on this website. For questions about an
                    active or prospective engagement, please contact us
                    directly using the details below.
                  </p>

                  <h4>7. Governing law and jurisdiction</h4>
                  <p>
                    These Terms and Conditions, and any dispute or claim arising
                    out of or in connection with them or their subject matter,
                    shall be governed by and construed in accordance with the
                    laws of India, without regard to its conflict of law
                    provisions. You agree that any legal action or proceeding
                    arising out of these terms shall be brought exclusively in
                    the courts having jurisdiction over ITCODE InfoTech's
                    registered place of business, and you consent to the
                    jurisdiction of such courts.
                  </p>

                  <h4>8. Changes to these terms</h4>
                  <p>
                    ITCODE InfoTech may, at any time, revise these Terms and
                    Conditions by updating this page. Since you are bound by
                    these Terms and Conditions, please visit this page
                    regularly to learn about any revisions.
                  </p>

                  <h4>9. Contact us</h4>
                  <p>
                    If you have any questions about these Terms of Use, please{" "}
                    <a href={process.env.PUBLIC_URL + "/contact"}>contact us</a>{" "}
                    or write to us at{" "}
                    <a href="mailto:info@itcodeinfotech.com">
                      info@itcodeinfotech.com
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default TermsOfUse;
